import React from 'react';
import logo2 from 'assets/images/logo2.svg';

const LeftPanelCopyrights = () => (
  <div className="copyrights">
    <a href="https://kivy.pl">
      <span className="copyrights-text">Created by</span><span className="kivy-logo"><img src={logo2} alt="" /></span>
    </a>
  </div>
);

export default LeftPanelCopyrights;


// WEBPACK FOOTER //
// ./src/partialComponents/LeftPanelCopyrights.jsx